import React from 'react';

function ProductItem({ left, image, heading, features }) {
  const contentOrder = left ? 'order-1' : 'order-2';
  const imageOrder = left ? 'order-2' : 'order-1';

  return (
    <div className="flex flex-col md:flex-row items-center gap-8 p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10">
      <div className={`w-full md:w-1/2 ${contentOrder}`}>
        <h3 className="text-3xl font-medium mb-6 text-white">
          {heading}
        </h3>
        <ul className="space-y-4">
          {features.map((feature, index) => (
            <li 
              key={index}
              className="flex items-start"
            >
              <div className="p-2 rounded-lg bg-white/5 border border-white/10 mr-4">
                <img 
                  src={feature.icon} 
                  alt="" 
                  className="w-5 h-5 brightness-0 invert"
                  loading="lazy"
                  width={20}
                  height={20}
                />
              </div>
              <div>
                <h4 className="text-white text-base font-medium mb-1">
                  {feature.heading}
                </h4>
                <p className="text-white/70 text-sm">
                  {feature.content}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className={`w-full md:w-1/2 ${imageOrder}`}>
        <img 
          src={image} 
          alt={heading} 
          className="w-full rounded-xl shadow-lg shadow-[#C334F6]/10"
          loading="lazy"
          width={600}
          height={400}
        />
      </div>
    </div>
  );
}

export default React.memo(ProductItem);